{
  "confirmationNumber": "Número de confirmación {number}",
  "dateTimeRange": "{date} de {startTime} a {endTime}"
}
